import { useDashboard } from '@cobliteam/dashboard/src/providers/DashboardProvider';
import { useLanguage } from '@cobliteam/i18n';
import Typography from '@cobliteam/ui/components/Typography';
import { getTextForLanguage } from '@cobliteam/ui-business/utils';
import { useEffect } from 'react';
import PageHeaderTitle from '../PageHeader/components/PageHeaderTitle';
import PageInfo from '../PageInfo';

interface PageTitleProps {
  title?: string;
  description?: string;
  pageInfoOpen?: boolean;
  onPageInfoOpenChange?: (open: boolean) => void;
}

const PageTitle = ({ title, description, pageInfoOpen, onPageInfoOpenChange }: PageTitleProps) => {
  const { sidebar } = useDashboard();
  const { currentLanguage } = useLanguage();
  const page = sidebar?.route?.page;
  const pageTitle = getTextForLanguage(sidebar?.route?.page?.title, currentLanguage) || 'Sem título';
  const finalTitle = title || pageTitle;

  useEffect(() => {
    if (finalTitle && finalTitle !== 'Sem título') {
      document.title = `Cobli - ${finalTitle}`;
    }
  }, [finalTitle]);

  return (
    <PageHeaderTitle>
      <div className='flex items-center'>
        <Typography variant='heading-4xl' className='mr-2 first-letter:uppercase' as='h1' data-testid='page-title'>
          {finalTitle}
        </Typography>
        <PageInfo open={pageInfoOpen} onOpenChange={onPageInfoOpenChange} />
      </div>
      {(page?.description || description) && (
        <div className='mt-1 flex items-center' data-testid='page-description'>
          <Typography variant='text-lg' className='mr-2' color='secondary'>
            {page?.description ? getTextForLanguage(page?.description, currentLanguage) : description || ''}
          </Typography>
        </div>
      )}
    </PageHeaderTitle>
  );
};

export default PageTitle;
